import { render, staticRenderFns } from "./versionList.vue?vue&type=template&id=15dde89f"
import script from "./versionList.vue?vue&type=script&lang=js"
export * from "./versionList.vue?vue&type=script&lang=js"
import style0 from "./versionList.vue?vue&type=style&index=0&id=15dde89f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports